import { type DeviceKinematics } from '@sb/motion-planning';

import type { MillerWeldMachineConfiguration } from '../types/MillerWeldMachineConfiguration';

export class MillerWeldMachineKinematics implements DeviceKinematics<unknown> {
  public config?: MillerWeldMachineConfiguration;

  public name = 'MillerWeldMachine';
}
